import { useEffect } from 'react';
import { addClientTiming } from './clientMonitoring';

export const AUTH_SCREEN_READY_EVENT = 'lt:auth-screen-ready';
export const AUTH_SCREEN_READY_MAX_WAIT_MS = 10000;
const AUTH_SCREEN_READY_TIMING = 'auth_screen_ready';

declare global {
  interface Window {
    __ltAuthScreenReady?: boolean;
  }
}

export const isAuthScreenReady = (): boolean =>
  window.__ltAuthScreenReady === true;

export const useAuthScreenReady = (screenName?: string): void => {
  useEffect(() => {
    if (!screenName || isAuthScreenReady()) {
      return;
    }

    window.__ltAuthScreenReady = true;
    addClientTiming(AUTH_SCREEN_READY_TIMING);
    window.dispatchEvent(
      new CustomEvent(AUTH_SCREEN_READY_EVENT, {
        detail: { screenName },
      })
    );
  }, [screenName]);
};
